import React from "react";

const details = [
  {
    title: "Instant review",
    description: "get approved in seconds and start earning",
  },
  {
    title: "No hidden fees",
    description: "commission paid on successful bookings only",
  },
  {
    title: "24/7 support",
    description: "we are always here for you and your customers",
  },
  {
    title: "International reach",
    description: "millions of travelers in 190+ countries",
  },
];

function HomeHeroSection() {
  const handleGetStarted = () => {};

  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <div className={Classname.textContent}>
          <span className={Classname.title}>{`You could earn`}</span>
          <span
            className={`${Classname.title} text-primary`}
          >{`₦5,000,000 per month `}</span>
          <span className={Classname.title}>{`in Nigeria`}</span>
          <div className="flex flex-col gap-4">
            <span className="text-sm lg:text-base mt-6">
              Publishing your activity on Intraverse is free and easy.
            </span>
            {details.map((detail, index) => (
              <div key={index} className="text-[#091D41] flex items-center">
                <div className="text-[#091D41] mr-2">●</div>

                <span className="font-bold text-sm lg:text-base">
                  {detail.title} :{" "}
                  <span className="font-normal">{detail.description}</span>
                </span>
              </div>
            ))}
          </div>
          <button
            className="bg-primary text-sm lg:text-base font-bold text-white rounded-lg px-6 py-2 mt-10"
            onClick={handleGetStarted}
          >
            Get Started
          </button>
          <div className="flex flex-col lg:flex-row gap-3 items-center mt-7">
            <img
              src="/homeHeroImage.png"
              alt=""
              className="h-11 object-contain"
            />
            <div className="flex flex-col text-sm">
              <span>{`20,000+ suppliers earn`}</span>
              <span>more with Intraverse</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeHeroSection;

const Classname = {
  container:
    "w-full flex justify-center pt-32 md:pt-32 md:min-h-screen px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl gap-10 px-2 xl:px-0",
  textContent:
    "flex flex-col flex-1 w-full items-center md:items-start md:pt-32 max-w-4xl z-10",
  heroImageMobile: "flex md:hidden",
  imageContent:
    "hidden md:flex flex-col relative md:absolute items-end bottom-0 right-0 max-w-4xl",
  title:
    "text-4xl md:text-6xl text-textPrimary font-black text-center md:text-start mb-2",
  description:
    "text-tertiary text-center md:text-start text-sm md:text-base max-w-md mt-7",
  buttons:
    "flex flex-col xs:flex-row items-center gap-2 md:gap-4 mt-10 mb-10 md:mb-0",
  tryButton:
    "h-12 px-4 md:w-44 rounded-lg md:rounded-full bg-primary cursor-pointer flex items-center justify-center gap-3 text-white font-bold text-sm md:text-base",
  arrowIcon: "w-4 h-4 object-contain",
  watchButton:
    "px-4 md:w-56 h-12 flex items-center justify-center font-bold text-primary border-3 border-primary rounded-lg md:rounded-full text-sm md:text-base",
};
